export default {
  meta: {
    title: $localize`:@@meta.super-wheel.home.title:Crazy Wheel CSGO`,
    description: $localize`:@@meta.super-wheel.home.desc:Играй на проекте CSFAIL! Узнаешь как играть и выигрывать в Crazy Wheel кс го за считанные минуты! Заходи и пробуй, тысячи игроков уже здесь!`
  }
};